import React, { useEffect, useRef, useState } from "react";
import { Icon } from "semantic-ui-react";
import "../stylesheets/landingPageStyles.css";
import ImageWithFallback from "../../Shared Components/imageWithFallback";

export default function WhatGFGHaveToOffer(props) {
  const ref = useRef();
  const divRefLeft = useRef();
  const divRefRight = useRef();

  const [extraFields, setExtraFields] = useState({
    currentSelectedIndexCourseFeature: 0,
    clamped: true,
    hasMoreContent: true,
    readMoreButtonMobile: true,
    selectedIndexMobile: false,
  });

  function scroll(scrollOffset) {
    ref.current.scrollLeft += scrollOffset;
  }

  function contentActionHandler() {
    setExtraFields((prevState) => ({
      ...prevState,
      clamped: !extraFields?.clamped,
    }));
  }

  const checkAvailability = () => {
    var el = document.querySelector(
      `#course_feature_content_${extraFields?.currentSelectedIndexCourseFeature}`
    );

    const { clientHeight, scrollHeight } = el;
    return clientHeight !== scrollHeight;
  };

  function readMoreMessage(description) {
    return (
      <>
        <span
          dangerouslySetInnerHTML={{ __html: description }}
          className={extraFields?.clamped ? "clamp" : ""}
          id={`course_feature_content_${extraFields?.currentSelectedIndexCourseFeature}`}
        />
        {extraFields?.hasMoreContent && (
          <span onClick={contentActionHandler} className="read-less-btn">
            {" "}
            Read {extraFields?.clamped ? "more" : "less"}
          </span>
        )}
      </>
    );
  }

  function readMoreMessageForMobile(description, selectedIndex) {
    let desc = description ? description.substring(0, 200) : description;
    let readMore = "Read more...";
    if (
      extraFields.selectedIndexMobile === selectedIndex &&
      extraFields.readMoreClicked
    ) {
      desc = description;
      readMore = "";
    }
    return (
      <>
        <span dangerouslySetInnerHTML={{ __html: desc }} />
        <span>
          {description && description.length > 200 ? (
            // Show complete text on read more
            <span
              className="read-more-btn"
              onClick={() => {
                setExtraFields({
                  selectedIndexMobile: selectedIndex,
                  readMoreClicked: true,
                });
              }}
            >
              {" "}
              {readMore}
            </span>
          ) : (
            ""
          )}
        </span>
        {desc === description &&
        extraFields.readMoreClicked &&
        extraFields.selectedIndexMobile === selectedIndex ? (
          <span
            className="read-less-btn"
            onClick={() => {
              setExtraFields((prevState) => ({
                ...prevState,
                readMoreClicked: false,
              }));
              readMoreMessage(description, 200, selectedIndex);
            }}
          >
            Read less...
          </span>
        ) : (
          ""
        )}
      </>
    );
  }

  function getCurrentTab() {
    return (
      <div className="course_feature_details_container">
        <div className="course_feature_details_image">
          <ImageWithFallback
            src={
              props.data.courseFeaturesList?.[
                extraFields?.currentSelectedIndexCourseFeature
              ]?.web_thumbnail
            }
            fallbackSrc={props?.data?.addOnsDefaultThumbnail}
            alt="course feature img"
          />
        </div>
        <div className="course_feature_details_desc">
          <div className="course_feature_desc_header">
            {
              props.data.courseFeaturesList?.[
                extraFields?.currentSelectedIndexCourseFeature
              ]?.feature_name
            }
          </div>
          <div className="course_feature_content">
            <p>
              {readMoreMessage(
                props.data.courseFeaturesList?.[
                  extraFields?.currentSelectedIndexCourseFeature
                ]?.feature_desc
              )}
            </p>
          </div>
        </div>
      </div>
    );
  }

  useEffect(() => {
    if (
      ref.current?.offsetWidth >= ref.current?.scrollWidth &&
      ref.current?.offsetWidth > 0 &&
      ref.current?.scrollWidth > 0
    ) {
      divRefLeft.current.hidden = true;
      divRefRight.current.hidden = true;
    }
  });

  useEffect(() => {
    setExtraFields((prevState) => ({
      ...prevState,
      hasMoreContent: checkAvailability(),
    }));
  }, [props, extraFields?.currentSelectedIndexCourseFeature]);

  return (
    <section>
      {/* For Web */}
      {props.data?.courseFeaturesList.length ? (
        <div className="col-11 col-sm-9 col-lg-9 mx-auto course_feature_web">
          <h2 className="font-weight-bold sofia-pro mb-4">
            What Sets Us Apart
          </h2>
          <div className="course_feature_header_main_container" ref={ref}>
            <div className="angle_container left_arrow" ref={divRefLeft}>
              <Icon
                name="angle left"
                color="grey"
                onClick={() => scroll(-100)}
              />
            </div>
            <div className="course_feature_main_container">
              {props.data?.courseFeaturesList.map((item, index) => (
                <div>
                  <div
                    className={`course_feature_header ${
                      extraFields?.currentSelectedIndexCourseFeature === index
                        ? "course_feature_header_active"
                        : ""
                    }`}
                    onClick={() => {
                      setExtraFields((prevState) => ({
                        ...prevState,
                        currentSelectedIndexCourseFeature: index,
                        readMoreClicked: false,
                        clamped: true,
                      }));
                    }}
                  >
                    <p>{item?.feature_name}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="angle_container right_arrow" ref={divRefRight}>
              <Icon
                name="angle right"
                color="grey"
                onClick={() => scroll(100)}
              />
            </div>
          </div>

          {getCurrentTab()}
        </div>
      ) : (
        ""
      )}

      {/* For Mobile   */}
      {props.data?.courseFeaturesList.length ? (
        <div className="course_feature_mobile">
          <h2 className="font-weight-bold sofia-pro mb-4">
            What Sets Us Apart
          </h2>
          <div className="course_feature_mobile_inner">
            {props.data?.courseFeaturesList.map((item, index) => (
              <div className="course_feature_container">
                <div className="course_feature_mobile_head">
                  <div>
                    <ImageWithFallback
                      src={item?.mobile_thumbnail}
                      fallbackSrc={props?.data?.addOnsDefaultThumbnail}
                      alt="course feature mobile img"
                      className="course_feature_mobile_image mr-2"
                    />
                  </div>
                  <div className="course_feature_mobile_name">
                    {item?.feature_name}
                  </div>
                </div>
                <div className="course_feature_mobile_desc mt-2">
                  {readMoreMessageForMobile(item?.feature_desc, index)}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        ""
      )}
    </section>
  );
}
